import FormattedMessage from 'I18n/components/FormattedMessage';
import { UncategorizedFeatures } from '../UncategorizedFeatures';
import { usePriorityFeaturesForApiName } from '../useFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductTileFeaturesContainer = ({
  apiName,
  isCollapsible = false
}) => {
  const {
    loading,
    features
  } = usePriorityFeaturesForApiName({
    apiName
  });
  if (features.length) {
    return /*#__PURE__*/_jsx(UncategorizedFeatures, {
      uncategorizedFeatures: features,
      loading: loading,
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `productTile.${apiName}.businessObjectives.lowerTierPlus`
      }),
      isCollapsible: isCollapsible
    });
  }
  return null;
};